<template>
    <div class="zs_view_content">
        <div class="page-container">
            <div v-if="loading" v-loading="loading" :element-loading-text="$tx('common.loading', '正在加载...')" />
            <div v-if="!loading" class="form-container" style="padding-bottom: 30px; padding: 30px 100px">
                <div class="form-header">
                    <div class="form-title">
                        <div v-if="viewContent === '1'" class="form-title-child">
                            {{ vo.title || vo.subject || vo.flSubject }}
                        </div>
                    </div>
                    <div class="section-title">
                        <span class="r-text">
                            <span v-text-lbl="'yoabase.viewContent.author'">作者：</span>
                            {{ vo.flCreator || vo.createName || vo.pubUser || vo.creator }}
                        </span>
                        <span class="r-text">
                            <span v-text-lbl="'yoabase.viewContent.issueDate'">发布时间：</span>
                            {{ vo.issueDate | dateTransform }}
                        </span>
                        <span class="r-text">
                            <svg-icon icon-class="liulan" style="width: 16px; height: 16px; padding-top: 4px" />
                            <span style="margin-left: 5px">
                                {{ vo.visitCounts || vo.readNum || vo.visitNum || vo.pviews || 0 }}
                                <span v-text-lbl="'yoabase.viewContent.count'">次</span>
                            </span>
                        </span>
                        <span v-if="showCollection == true || showCollection == 'true'" class="r-text">
                            <svg-icon
                                v-if="!collectionStatus"
                                icon-class="fiveStar"
                                :style="{
                                    width: '13px',
                                    height: '13px',
                                    cursor: wfParams.readonly ? 'default' : 'pointer'
                                }"
                                @click="collection()"
                            />
                            <svg-icon
                                v-else
                                icon-class="fiveStar1"
                                :style="{
                                    width: '13px',
                                    height: '13px',
                                    cursor: wfParams.readonly ? 'default' : 'pointer'
                                }"
                                @click="collection()"
                            />
                            <span style="margin-left: 5px">{{ collectionNum || 0 }} 次</span>
                        </span>
                    </div>
                    <!-- 标签 -->
                    <div v-if="vo.labelNames && vo.labelNames.split(',').length > 0" class="labelBox" style="color: #999">
                        <div>
                            <span v-text-lbl="'yoabase.viewContent.labelNames'">标签：</span>
                            <span v-for="(item, index) in vo.labelNames.split(',')" :key="index" style="margin-right: 10px">{{ item }}</span>
                        </div>
                        <div style="border-bottom: 1px solid #edebf0; margin: 15px 0; width: 100%" />
                    </div>
                </div>

                <!-- 内容 -->
                <ViewBodyArticle v-if="viewContent === '1'" :article-data="vo.content" />
                <div v-if="viewContent === '2' || viewContent === '3' || viewContent === '4'" style="color: #666666; line-height: 24px; white-space: pre-line" v-text="vo.remark"></div>
                <div v-if="viewContent === '3' && vo.pictureName" style="text-align: center">
                    <img class="courseImg" :src="base_api + '/zsgl/map/map/download?nameField=pictureName&id=' + vo.id" alt="" style="width: 100%" />
                </div>
                <div v-if="viewContent === '4' && vo.coverName" style="text-align: center">
                    <img class="courseImg" :src="base_api + '/zsgl/config/mapTemplate/download?dataField=coverData&nameField=coverName&id=' + vo.id" alt="" style="width: 100%" />
                </div>
            </div>
            <!-- 附件 -->
            <div v-if="viewContent !== '3'">
                <!-- 知识附件 -->
                <div v-if="viewContent === '1'">
                    <div v-if="attachments.filter((obj) => obj.fileType === 'ATTACH').length > 0" style="padding-bottom: 30px; margin: 0 100px">
                        <div v-text-lbl="'yoabase.viewContent.KnowledgeAttachment'" class="titleAttachment" style="margin-bottom: 20px">附件：</div>
                        <div v-for="(item, index) in attachments.filter((obj) => obj.fileType === 'ATTACH')" :key="index" @click="handleUploadPreview(item, true)">
                            <div style="display: flex; align-items: center; cursor: pointer; line-height: 3">
                                <svg-icon :icon-class="changeIcons(item.fileName)" style="width: 16px; height: 16px" />
                                <span style="margin-left: 10px; color: #333">{{ item.fileName }}</span>
                                <span style="margin-left: 20px; color: #999">
                                    {{ item.fileSize }}
                                </span>
                                <span v-if="item.fileName.indexOf('.doc') > -1 || item.fileName.indexOf('.docx') > -1 || item.fileName.indexOf('.pdf') > -1 || item.fileName.indexOf('.PDF') > -1" style="margin-left: 20px; color: #63adff" @click="handleUploadPreview(item, true)">预览</span>
                                <span v-text-lbl="'yoabase.common.dowload'" style="margin-left: 20px; color: #63adff" @click="handleUploadPreview(item, false)">下载</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="keyWordsList.length" style="display: flex; margin: 0 100px 20px 100px">
                    <div v-for="(item, index) in keyWordsList" :key="index" style="margin-right: 10px" @click="openWorkFlow(item)">
                        <el-button type="primary" size="small" plain round>
                            {{ item }}
                        </el-button>
                    </div>
                </div>
                <!-- </div> -->
            </div>
        </div>
        <!-- 评论 -->
        <div v-if="showComment === true || showComment === 'true'" class="page-container comment-discuss" style="min-height: 30%">
            <comment :vo="vo" :work-type="passageType" :readonly="wfParams.readonly" class="form-container" style="padding-top: 30px" />
        </div>
    </div>
</template>

<script>
// _this.$options.components['BusiForm'] = _this.$loadComponent("#/dcontent/vuebusiform/W/htgl.htda.htdaDetail.vue?sysCode="+_this.$route.meta.sysCode)
const moment = require('moment')
import { mapGetters } from 'vuex'

export default {
    filters: {
        dateTransform: function (val) {
            if (val) {
                return moment(new Date(val)).format('YYYY-MM-DD HH:mm:ss')
            }
            return '-'
        }
    },
    props: {},
    data() {
        return {
            loading: true,
            wfParams: {},
            wfInstance: {},
            vo: {},
            wfJsonData: {},
            curTN: {},
            attachments: [],
            viewContent: '',
            base_api: '',
            fileList: [],
            mapCatalogueTree: [],
            passageType: '',
            collectionStatus: false, // 收藏状态
            collectionNum: 0,
            keyWordsList: [],
            contentTitle: '',
            wfEngineUrl: '', // 文章接口
            wflowType: 'wflow', //  通过流程接口获取数据 还是 通过getById， 默认wflow
            showCollection: true, // 是否显示收藏
            showComment: true, // 是否显示评论
            apiFlag: true // 是否需要通过调接口来获取 浏览量
        }
    },
    computed: {
        ...mapGetters(['routes', 'loginUser']),
        publishTime() {
            if (this.vo.signDate !== undefined && this.vo.signDate !== null) {
                return this.vo.signDate.split('.')[0]
            } else {
                return this.vo.publishDate
            }
        },
        // 知识信息
        changeIcons() {
            return (name) => {
                // if()
                const last = name.split('.').pop()
                if (last === 'doc' || last === 'doc') {
                    return 'word1'
                } else if (last === 'ppt') {
                    return 'ppt1'
                } else if (last === 'txt') {
                    return 'txt1'
                } else if (last === 'xlsx' || last === 'xls') {
                    return 'excel1'
                } else if (last === 'jpg' || last === 'jpeg' || last === 'Jpeg' || last === 'png' || last === 'gif' || last === 'bmp') {
                    return 'file_img'
                } else {
                    return 'pdf1'
                }
            }
        }
    },
    watch: {},
    created() {
        this.$options.components['comment'] = this.$loadComponent('@/wapp/zsgl/components/comment/ZsglCommentIndex.vue')
        this.$options.components['ViewBodyArticle'] = this.$loadComponent('@/wapp/common/components/ViewBodyArticle/index')

        this.viewContent = this.$route.query.viewContent
        this.wfEngineUrl = this.$route.query.wfEngineUrl
        if (this.$route.query.wflowType) {
            this.wflowType = this.$route.query.wflowType
        }
        if (this.$route.query.passageType) {
            this.passageType = this.$route.query.passageType
        }
        if (this.$route.query.apiFlag) {
            this.apiFlag = this.$route.query.apiFlag
        }
        if (this.$route.query.showCollection) {
            this.showCollection = this.$route.query.showCollection
        }
        if (this.$route.query.showComment) {
            this.showComment = this.$route.query.showComment
        }
        this.wfParams = this.$route.query
        this.base_api = process.env.VUE_APP_BASE_API
        if (!this.wfEngineUrl) {
            this.$alert(this.$tx('yoabase.alerts.parameterException', '参数异常，wfEngineUrl是必须的。'), this.$tx('yoabase.alerts.cozyTip', '温馨提示'), {
                confirmButtonText: this.$tx('yoabase.alerts.sure', '确定'),
                callback: (action) => {
                    window.close()
                }
            })
            return
        }
        if (/\/$/.test(this.wfEngineUrl)) {
            // this.wfEngineUrl 以 '/' 结尾，则同意去掉
            this.wfEngineUrl = this.wfEngineUrl.substring(0, this.wfEngineUrl.length - 1)
        }
        if (this.wflowType === 'getById') {
            this.getViewContentData()
        } else {
            this.loadWfInstance()
        }
    },
    beforeDestroy() {},
    mounted() {
        this.getCollectionNumber()
        this.getCollectionStatus()
        const cookieStyle = this.Cookies.get('uiStyle')
        let style = ''
        if (cookieStyle !== this.loginUser.uiStyle) {
            style = this.loginUser.uiStyle
            this.Cookies.set('uiStyle', style)
        } else {
            style = cookieStyle
        }
        document.querySelector('body').setAttribute('id', this.loginUser.orgCode !== 'plat' ? style : 'skinScienceBlue')
    },
    methods: {
        // 更新阅读量
        updatePviewsCms() {
            if (this.$route.query.readonly) return
            this.$http({
                contentType: 'application/x-www-form-urlencoded',
                url: '/portal/cms/article/getByReadNum?id=' + this.$route.query.busiDataId,
                method: 'get'
            }).then((res) => {
                this.vo.readNum++
            })
        },
        updatePviews() {
            if (this.$route.query.readonly) return
            this.$http({
                contentType: 'application/x-www-form-urlencoded',
                url: `${this.wfEngineUrl}/updatePviews`,
                method: 'POST',
                data: {
                    id: this.$route.query.busiDataId,
                    type: this.$route.query.viewContent
                }
            }).then((res) => {
                this.vo.visitCounts++
                this.vo.pviews++
            })
        },
        // 收藏
        collection() {
            if (this.wfParams.readonly) {
                return
            }
            this.$http({
                contentType: 'application/x-www-form-urlencoded',
                url: '/user/collection/addNew',
                method: 'POST',
                data: {}
            }).then((res) => {
                if (res.code === 'success') {
                    console.log(res.body, this, '333')
                    var vo = res.body.vo
                    vo.busiDataId = this.$route.query.busiDataId
                    let str = ''
                    const href = decodeURIComponent(location.href)
                    const arr = href.split('?')[1].split('&')
                    arr.forEach((item) => {
                        if (item.indexOf('wfEngineUrl') > -1) {
                            str = item.split('/')[1]
                        }
                    })
                    if (this.$route.query.viewContent === '1') {
                        vo.title = this.vo.flSubject ? this.vo.flSubject : this.vo.subject
                    } else {
                        vo.title = this.vo.subject
                    }
                    vo.type = this.passageType
                    vo.url = this.$route.fullPath
                    vo.operationType = 1
                    if (this.wflowType === 'getById') {
                        if (str === 'knowledgeInfo') str = 'knowledge'
                        vo.module = str
                    } else {
                        vo.module = this.wfInstance.module
                    }
                    if (this.wfEngineUrl === 'portal/cms/article') {
                        vo.sysCode = this.$store.getters.loginUser.sysCode
                    } else if (this.wflowType === 'wflow') {
                        if (this.vo.sysCode) {
                            vo.sysCode = this.vo.sysCode
                        } else {
                            vo.sysCode = this.wfInstance.sysCode
                        }
                    } else if (this.wflowType === 'getById') {
                        if (this.vo.sysCode) {
                            vo.sysCode = this.vo.sysCode
                        } else {
                            var code = this.wfEngineUrl.split('/')
                            vo.sysCode = `${this.vo.orgCode}_ecy${code[0] ? code[0] : code[1]}`
                        }
                    } else {
                        vo.sysCode = this.$store.getters.loginUser.sysCode
                    }
                    if (vo.type === '') {
                        vo.type = '文件'
                    }
                    if (!vo.title) {
                        vo.title = this.vo.title
                    }
                    this.$http({
                        contentType: 'application/x-www-form-urlencoded',
                        url: '/user/collection/insert',
                        method: 'POST',
                        data: vo
                    }).then((innerRes) => {
                        if (innerRes.code === 'success') {
                            this.collectionStatus = !this.collectionStatus
                            this.$message.success(innerRes.message)
                            this.getCollectionNumber()
                        } else {
                            this.$message.error(innerRes.message)
                        }
                    })
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        // 获取文章收藏状态
        getCollectionStatus() {
            this.$http({
                contentType: 'application/x-www-form-urlencoded',
                url: `/user/collection/getIfCollection?busiDataId=${this.$route.query.busiDataId}&operationType=1&ownerId=${this.loginUser.personId}`,
                method: 'GET'
            }).then((res) => {
                if (res.code === 'success') {
                    this.collectionStatus = res.body.data
                } else {
                    this.$alert.error(res.message)
                }
            })
        },
        // 获取文章收藏数量
        getCollectionNumber() {
            this.$http({
                contentType: 'application/x-www-form-urlencoded',
                url: `/user/collection/getCollectionCount?busiDataId=${this.$route.query.busiDataId}&operationType=1`,
                method: 'GET'
            }).then((res) => {
                if (res.code === 'success') {
                    this.collectionNum = res.body.data
                    console.log(res.body.data, '收藏量')
                } else {
                    this.$message.error(res.message)
                }
            })
        },
        insertBrowsingHistory(data) {
            const dataUrl = location.hash.substr(1)
            const params = {
                title: data.title,
                busiCode: 'xxfb',
                busiType: '信息发布',
                busidataId: data.id,
                dataUrl
            }
            this.$wappUtils.setBrowsingHistory(this, params)
        },
        loadWfInstance() {
            this.$wfEngine.loadWfInstance(this, this.wfParams).then((rst) => {
                if (rst.code === 'success') {
                    this.loading = false
                    // rst.body.wfInstance = this.vo
                    this.attachments = rst.body.attachList
                    if (!this.vo.content) {
                        this.vo.content = this.vo.flContent
                    }
                    if (!this.vo.issueDate) {
                        this.vo.issueDate = this.vo.publishDate || this.vo.publishTime || this.vo.pushTime || this.vo.pubTime || this.vo.createTime
                    }
                    if (this.apiFlag === false || this.apiFlag === 'false') return
                    if (this.wfEngineUrl === 'portal/cms/article') {
                        this.updatePviewsCms()
                    } else {
                        this.updatePviews()
                    }
                } else {
                    this.$alert(rst.message, this.$tx('common.operationTip', '操作提示'), {
                        type: 'error',
                        callback: () => {
                            window.close()
                        }
                    })
                }
            })
        },
        getViewContentData() {
            if (this.viewContent === '1') {
                this.$http({
                    contentType: 'application/x-www-form-urlencoded',
                    url: `${this.wfEngineUrl}/getById?id=${this.$route.query.busiDataId}`,
                    method: 'GET',
                    data: {}
                }).then((res) => {
                    this.loading = false
                    if (res.code === 'success') {
                        this.vo = res.body.vo
                        if (!this.vo.content) {
                            this.vo.content = this.vo.flContent
                        }
                        if (!this.vo.issueDate) {
                            this.vo.issueDate = this.vo.publishDate || this.vo.publishTime || this.vo.pushTime || this.vo.pubTime || this.vo.createTime
                        }
                        debugger
                        this.insertBrowsingHistory(this.vo)
                        if (this.vo.passenger.attachments) {
                            this.attachments = this.vo.passenger.attachments
                        } else {
                            this.attachments = []
                        }
                        if (this.vo.keyWords) {
                            this.keyWordsList = this.vo.keyWords.split('、')
                        }
                        if (this.vo.passenger.liuNumber) {
                            this.$set(this.vo, 'pviews', this.vo.passenger.liuNumber)
                        }

                        if (this.apiFlag === false || this.apiFlag === 'false') return
                        if (this.wfEngineUrl === 'portal/cms/article') {
                            this.updatePviewsCms()
                        } else {
                            this.updatePviews()
                        }
                    } else {
                        this.$alert(res.message, this.$tx('common.operationTip', '操作提示'), {
                            type: 'error',
                            callback: () => {
                                window.close()
                            }
                        })
                    }
                })
                this.wfInstance.wfName1 = '知识中心'
            }
        },
        getCookie(cname) {
            var name = cname + '='
            var ca = document.cookie.split(';')
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i].trim()
                if (c.indexOf(name) === 0) return c.substring(name.length, c.length)
            }
            return ''
        },
        // 知识信息 附件下载
        handleUploadPreview(attach, flang) {
            if (attach.id === undefined) return
            const type = attach.fileName.split('.')[attach.fileName.split('.').length - 1]
            if (type === 'png' && flang) {
                window.open(`#/imgView?wfAttachUrl=${this.wfEngineUrl}&busiDataId=${attach.busiDataId}`)
            } else {
                window.open(`${process.env.VUE_APP_BASE_API}/${this.wfEngineUrl}/downloadById?inline=${flang}&attachIds=${attach.id}&topdf=true`)
            }
        },
        // 关键词
        openWorkFlow(row) {
            if (!row) {
                return
            }
            window.open(`/#/commonHeader?workform=@/wapp/fzgl/flzx/zxwd/components/FzglFlzxZxwdViewKeyWords&workFlow=${row}&wfEngineUrl=fzgl/knowledge` + '&type=fzgl&logoTitle=' + encodeURIComponent('法治咨询/咨询列表'))
        }
    }
}
</script>

<style scoped lang="scss">
@import '~@/wapp/common/styles/variables.module.scss';
.zs_view_content {
    .page-container {
        // width: 1000px;
        // min-height: 50%;
        // background: #fff;
        // margin: 0 auto;

        .form-container {
            // width: 824px;
            // margin: 0 auto;
            // padding-top: 1px;
            // padding-bottom: 30px;
            .courseImg {
                max-width: 824px;
                padding: 15px;
            }
            /deep/ .el-table {
                .cell {
                    padding: 0 15px !important;
                }
                .el-table__row {
                    cursor: pointer;
                }
            }
            .zsztFj {
                /deep/ .el-table {
                    .el-table__header-wrapper {
                        th.is-leaf {
                            background: #f5f7fa;
                        }
                    }
                }
            }
            // /deep/ .el-table--border td, .el-table--border th, .el-table__body-wrapper .el-table--border.is-scrolling-left~.el-table__fixed{
            //     border-right: 0;
            // }
            .form-header {
                .form-title {
                    font-size: 24px;
                    font-weight: bold;
                    text-align: left;
                    margin: auto;
                    color: #333333;
                    padding: 30px 0 20px;
                    position: relative;
                    max-width: 100%;
                    width: max-content;
                    font-weight: 700;
                    .form-title-child {
                        // display: inline-block;
                        // text-align: center;
                        font-size: 24px;
                        font-weight: bold;
                        // margin-bottom: 14px;
                    }
                    .startBox {
                        position: absolute;
                        right: 0;
                        bottom: 23px;
                        font-size: 12px;
                        display: flex;
                        align-items: center;
                        color: #999999;
                    }
                }
                .section-title {
                    overflow: hidden;
                    line-height: 22px;
                    text-align: center;
                    // padding-bottom: 30px;
                    .l-text {
                        float: left;
                        margin-bottom: 0px;
                    }
                    .r-text {
                        color: #999999;
                        margin-right: 30px;
                    }
                }
                .labelBox {
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                    // padding-bottom: 10px;
                    .labelItem {
                        //   color: #999999;
                        //   border: 1px solid #999999;
                        padding: 5px 15px;
                        border-radius: 14px;
                        margin-right: 10px;
                        margin-bottom: 10px;
                    }
                }
            }

            /deep/ .richtext-container {
                margin-top: 5px;
            }

            .attach-list {
                height: 20px;
                margin: 10px 0px;
            }
        }

        /deep/ .el-loading-mask {
            margin-top: 100px;
        }
        /deep/ .view-body-article .view-article img {
            width: 100%;
            height: auto;
        }
    }
    .comment-discuss {
        position: relative;
        &::before {
            position: absolute;
            content: '';
            // height: 10px;
            top: 0;
            left: 0;
            background: #f3f3f3;
            // width: 1250px;
            width: 100%;
        }
    }
}

/deep/ .el-form .el-table__body {
    line-height: normal;
}
.titleAttachment {
    color: #333;
    font-size: 13px;
    font-weight: bold;
}
/deep/.el-button.el-button--primary.is-plain {
    color: #409eff;
    background: #ecf5ff;
    border-color: #ecf5ff;
}
</style>
